<template>
</template>

<script>
    import GlobalMixin from '@/app/shared/mixins/global';
    import ButtonControlMixin from '../mixins/ButtonControlMixin';

    let sv = null;
    export default {
        mixins: [
            GlobalMixin,
            ButtonControlMixin
        ],
        data() {
            return {
                idPanel: 'links',
                className: 'ol-links',
            }
        },
        methods: {
            addButtonMap: function(_map){
                let buttons = [];
                let items = this.tool.items || [];
                items.forEach(item => {
                    if(!item.active) {
                        return false;
                    }

                    let url = item.url;
                    if(!url.view || !this.$auth.check(item.acl.view)) {
                        return false;
                    }

                    let lblBtn = this.showLabelBtnMap && item.label ? this.$t(item.label) : null;
                    let btn = _map.createBtnImg(
                        this.assetsPathTheme(item.image ? item.image : '/map/backoffice.svg'),
                        _map.getControlClassName(this.orderClassName),
                        item.title,
                        [
                            {
                                type: 'click',
                                event: (evt) => {
                                    this.$router.push({ name: url.view.replace(':moduleCode', this.moduleCode) });
                                    evt.stopPropagation();
                                }
                            }
                        ],
                        lblBtn
                    );
                    _map.addControl(this.posBtnMap, btn);
                    this.$eventBus.listen(this.moduleCode, 'map.new-feature-initialize', (evt)=>{
                        let el = $(btn.element); if(el) el.hide()
                    });
                    this.$eventBus.listen(this.moduleCode, 'map.new-feature-finished', (evt)=>{
                        let el = $(btn.element); if(el) el.show()
                    });
                    buttons.push(btn);
                });
                return buttons;
            },
        }

    }
</script>

<style lang="scss">
.cursor-sv {
    cursor: url('../../../libraries/ol/StreetView/img/street_view_cursor.gif') 7.5 17.5, crosshair;
}
</style>
